import React from 'react';
import { observer } from 'mobx-react';

import * as RS from 'reactstrap';
import { Label } from 'sdc-i18n-react';

import { state } from './state';

/**
  @class
  a prompt featuring a caption and Delete and Cancel buttons
  @param {string} tag - the tag linking this prompt to any DeleteButtons
  @param {string} caption - the caption to translate
*/
export var DeletePrompt = observer(function (_ref) {
  var tag = _ref.tag,
      caption = _ref.caption;
  return React.createElement(
    RS.Modal,
    { isOpen: state.opened && state.opened[tag], centered: true },
    React.createElement(
      RS.ModalHeader,
      null,
      React.createElement(Label, { value: caption })
    ),
    React.createElement(
      RS.ModalFooter,
      null,
      React.createElement(
        'button',
        { className: 'btn btn-danger', onClick: state.proceed(tag) },
        React.createElement(Label, { value: 'action.delete' })
      ),
      React.createElement(
        'button',
        { className: 'btn', onClick: state.cancel(tag) },
        React.createElement(Label, { value: 'action.cancel' })
      )
    )
  );
});